export default __webpack_public_path__ + "static/media/worldwide-emergency-assistance-icon.ad71247d.svg";